import { FC, PropsWithChildren } from 'react';

export const SectionCard: FC<PropsWithChildren> = ({ children }) => {
  return (
    <section className="rounded-xl border border-(--neutral-black-NB100) bg-(--neutral-white-NW1000) p-6 shadow-sm">
      {children}
    </section>
  );
};
